module.exports = __webpack_public_path__ + "static/media/details-3.7345b9f6.jpeg";